<app-card [title]="report.nombre" [favorite]="report.favorito" [isActive]="report.activo" (favoriteEvent)="onFavorite($event)">
    <div *ngIf="report.auditoria?.fechaCreacion || report.auditoria?.nombreUsuarioModificacion" class="aditional-info">
        <span>{{ report.auditoria?.fechaCreacion | date : 'shortDate' }}</span>
        <span *ngIf="report.auditoria?.fechaCreacion && report.auditoria?.nombreUsuarioModificacion"> | </span>
        <span> {{ report.auditoria?.nombreUsuarioModificacion }}</span>
    </div>
    <p *ngIf="report.descripcion" class="description">{{ report.descripcion }}</p>
    <div class="options dropdown-center">
        <button type="button" class="btn" class="btn-generate" (click)="loadData()" [disabled]="!globalService.canUserEdit()">
            <p *ngIf="report.activo">Generar</p>
        </button>
        <button *ngIf="hasPermission" class="ellipsis" data-bs-toggle="dropdown" aria-expanded="false">
            <fa-icon class="icon" [icon]="faEllipsis"></fa-icon>
        </button>
        <ul class="dropdown-menu">
            <li><button [hidden]="!report.activo" class="dropdown-item" (click)="editReport()" [disabled]="!globalService.canUserEdit()">Editar</button></li>
            <li><button class="dropdown-item" (click)="deleteReport()" [disabled]="!globalService.canUserEdit()">Eliminar</button></li>
            <li><button [hidden]="!report.activo" class="dropdown-item" (click)="disableReport()" [disabled]="!globalService.canUserEdit()">Deshabilitar</button></li>
            <li><button [hidden]="report.activo" class="dropdown-item" (click)="disableReport()" [disabled]="!globalService.canUserEdit()">Habilitar</button></li>
        </ul>
    </div>
</app-card>

<ngx-ui-loader [loaderId]="'report-item-' + report.uuid" [hasProgressBar]="false"></ngx-ui-loader>
